import React, { useEffect, useState } from 'react';
import styles from '../../components/quiz/MultipleChoice.module.css'
import Swal from 'sweetalert2';

const MultipleChoice = (props) => {
    const [options, setOptions] = useState([])

    const [selectedOption, setSelectedOption] = useState(null);
    const [hasAnswered, setHasAnswered] = useState(false);
    const [correctAnswer, setCorrectAnswer] = useState("")

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        setHasAnswered(true);
        setTimeout(() => {
            props.handleSubmitClick(option)
            setHasAnswered(false);
        }, 2000)

    };

    useEffect(() => {
        if (!props.currentquestion || !props.currentquestion.MultiChoices) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Data',
                text: 'Invalid question data',
            });
            return;
        }
        
        // Define your custom separators
        const separator1 = "\x01\x1F";  // Start of Heading + Unit Separator for '|'
        const separator2 = "\x1B\x04";  // Escape + End of Transmission for ','
        const separator3 = "\x1F\x1B";  // Unit Separator + Escape for ';'
        
        // Split the MultiChoices data using separator1
        const multiChoicesParts = props.currentquestion.MultiChoices.split(separator1);
        
        if (multiChoicesParts.length < 2) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Format',
                text: 'Invalid question format',
            });
            return;
        }
        
        // Split options using separator2
        const opt = multiChoicesParts[1].split(separator2);
        
        // Check the answer index (optind) using separator3 for safety
        const optind = parseInt(multiChoicesParts[0], 10);
        
        if (isNaN(optind) || optind < 0 || optind >= opt.length) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Index',
                text: 'Invalid answer index',
            });
            return;
        }
        
        const ca = opt[optind];
        setOptions(opt);
        setCorrectAnswer(ca);
    }, [props.currentquestion]);



    //   const handleRadioChange = (event) => {
    //     setSelectedOption(event.target.value);
    //   };

    //   const resetRadioButtons = () => {
    //     if(selectedOption==''&& selectedOption=="")
    //     return
    //     props.handleSubmitClick(selectedOption);
    //     setSelectedOption("");
    //   };

    return (
        <div className={styles.question_container}>
            <div className={styles.options}>
                {options.map((option, index) => {
                    // Array of option letters
                    const optionLetters = ['A', 'B', 'C', 'D', 'E']; // Extend this array if there are more than 5 options
                    return (
                        <div
                            key={index}
                            className={`${styles.option} ${hasAnswered
                                ? option === correctAnswer
                                    ? styles.correct
                                    : selectedOption === option
                                        ? styles.incorrect
                                        : ''
                                : ''
                                }`}
                            onClick={() => !hasAnswered && handleOptionClick(option)}
                        >
                            {`${optionLetters[index]}. ${option}`} {/* Prepend the letter before the option */}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MultipleChoice;
